import type { SelectorOption } from './Components';

export const MINIMUM_CONTRAST_RATIO_PARAM = 'minimumContrastRatio';
export const SOURCE_URL_PARAM = 'sourceUrl';
export const SOURCE_JSON_PARAM = 'sourceJson';
export const USE_SOURCE_JSON_PARAM = 'useSourceJson';
export const TARGET_SUBSTRACT_COLOR_PARAM = 'targetSubstrateColor';
export const TARGET_URL_PARAM = 'targetUrl';
export const TRANSFER_CUSTOMER_ASSETS_PARAM = 'transferCustomerAssets';
export const USE_SMART_TEXT_TRANSFER_PARAM = 'useSmartTextTransfer';
export const PRIORITY_PARAM = 'priority';
export const FIX_LOGO_CONTRAST_PARAM = 'fixLogoContrast';

export const NONE_SELECTOR_OPTION: SelectorOption = { label: 'None', value: '' };
export const DEFAULT_PANEL_SELECTOR_OPTION: SelectorOption = { label: 'First', value: 'first' };
export const DEFAULT_CULTURE_OPTION: SelectorOption = { label: 'en-us', value: 'en-us' };
export const DEFAULT_TESTING_CLIENT_SELECTOR_OPTION: SelectorOption = {
    label: 'Playground',
    value: 'ei6RoGWRkvHFEtnza8hrSnlFxT4wsyBnXPa',
};

export const PRIORITY_OPTIONS: SelectorOption[] = [
    { label: 'speed', value: 'speed' },
    { label: 'quality', value: 'quality' },
    { label: 'balanced', value: 'balanced' },
];

// file deepcode ignore HardcodedNonCryptoSecret: API KEY is not a secret, used for testing purposes
export const AGS_API_KEY = 'ei6RoGWRkvHFEtnza8hrSnlFxT4wsyBnXPa';
export const AGS_VISTA_API_KEY = 'doUnpmod9tDLH2ztFqyGyVDKNg7QLEaDpAs';
export const API_KEY_PARAM_NAME = 'apiKey';
